<hyperkit-dialog class="hyperkit-component" headerText="Add to Hunt">
  <div class="container-fluid">
    <div class="row">
      <div class="container">
        <div>
          <hyperkit-typography
            variant="body"
            size="md"
            align="left"
            color="body"
            >Add up to 25 hunt packages to each open hunt.</hyperkit-typography
          >
        </div>
        @if (error) {
          <hyperkit-error [error]="error"></hyperkit-error>
        }
        <kendo-formfield>
          <label for="huntTemplate">
            <hyperkit-typography
              variant="emphasized"
              size="sm"
              align="left"
              color="primary"
              >Hunt</hyperkit-typography
            >
          </label>
          <kendo-combobox
            #combo
            [formControl]="hunt"
            [data]="huntData"
            [filterable]="true"
            textField="name"
            valueField="id"
            [valuePrimitive]="true"
            [popupSettings]="{ appendTo: 'component' }"
            (selectionChange)="onSelectionChange($event)"
            (focus)="combo.toggle(true)"
          >
          </kendo-combobox>
        </kendo-formfield>
        <hyperkit-button
          size="small"
          color="tertiary"
          text="Save"
          (click)="onSubmit()"
          [disabled]="!hunt.valid"
        ></hyperkit-button>
      </div>
    </div>
  </div>
</hyperkit-dialog>
